import { render, staticRenderFns } from "./AssetType.vue?vue&type=template&id=8cd62b48&"
import script from "./AssetType.vue?vue&type=script&lang=js&"
export * from "./AssetType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports